import { get } from "lodash"
import { Creators as ProfileCreators } from "model/profileModal"
import { getViewType, getSelectedModelId } from "modules/portfolio-root/selectors/portfolios"
import createModule from "../createModule"
import { filterTrades, getTradeTypeDisplay } from "./selectors"
import { getCsvRows, getFileName } from "./selectors/csv"
import { Creators } from "./model"
import view from "./view"
import { generateClassificationQueryForContributors, getClassifications } from "helpers/classification"
import { VIEW_TYPES } from "helpers/base"

export default createModule({
  view,
  externalProps: (state) => ({
    portfolioId: state.global.selected.portfolio,
    modelId: getSelectedModelId(state),
    account: state.global.selected.account,
    selectedExperiment: state.modules.experiments.selected,
    viewType: getViewType(state),
    classifications: getClassifications(state),
  }),
  required: ["account", "portfolioId", "on", "selectedExperiment", "modelId"],
  data: [{
    resource: "experimentDate",
    as: null,
    url: ({ portfolioId, selectedExperiment, on, modelId, viewType, base, classifications }) => {
      if (!selectedExperiment || !on) {
        return null
      }

      return {
        id: `${modelId}${portfolioId}${selectedExperiment.id}${on}${viewType === VIEW_TYPES.ACTIVE ? JSON.stringify(base) : ""}`,
        query: `query($on: Date!, $modelId: String!, $portfolioId:String!, $base: [PositionSetInput], $experimentId: String!) {
          model(id:$modelId){
            simulation (positionSet:{type: PORTFOLIO id:$portfolioId experimentId:$experimentId} base:$base from:$on to:$on){
              composition{
                modeledGmv
                referenceEquity
                positions{
                  id
                  modelProviderId
                  bloombergTicker
                  internalId
                  assetClass
                  currency
                  country
                  ${generateClassificationQueryForContributors("GICS", classifications)}
                  economicExposure: positionSetEconomicExposure
                }
              }
              percent: composition(scaleFormat: PERCENT_EQUITY_GMV){
                positions{
                  id
                  modelProviderId
                  bloombergTicker
                  internalId
                  assetClass
                  activePercentEquity: economicExposure
                  positionPercentEquity: positionSetEconomicExposure
                  basePercentEquity: baseEconomicExposure
                }
              }
            }
          }
        }`,
        variables: {
          on,
          portfolioId,
          experimentId: selectedExperiment.id,
          modelId,
          base: viewType === VIEW_TYPES.ACTIVE ? [base] : undefined,
        },
      }
    },
  }, {
    resource: "basePortfolioPositionDate",
    as: null,
    url: ({ portfolioId, on, modelId, viewType, base, classifications }) => {
      if (!on) {
        return null
      }

      return {
        id: `${modelId}${portfolioId}${on}${viewType === VIEW_TYPES.ACTIVE ? JSON.stringify(base) : ""}`,
        query: `query($on: Date!, $modelId: String!, $base: [PositionSetInput], $portfolioId:String!) {
          model(id:$modelId){
            simulation (positionSet:{type: PORTFOLIO id:$portfolioId} base:$base from:$on to:$on){
              composition{
                modeledGmv
                referenceEquity
                positions{
                  id
                  modelProviderId
                  bloombergTicker
                  internalId
                  assetClass
                  currency
                  country
                  ${generateClassificationQueryForContributors("GICS", classifications)}
                  economicExposure: positionSetEconomicExposure
                }
              }
              percent: composition(scaleFormat: PERCENT_EQUITY_GMV){
                positions{
                  id
                  modelProviderId
                  bloombergTicker
                  internalId
                  assetClass
                  activePercentEquity: economicExposure
                  positionPercentEquity: positionSetEconomicExposure
                  basePercentEquity: baseEconomicExposure
                }
              }
            }
          }
        }`,
        variables: {
          on,
          portfolioId,
          modelId,
          base: viewType === VIEW_TYPES.ACTIVE ? [base] : undefined,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    ...get(state, "modules.experimentTrades"),
    tradeType: getTradeTypeDisplay(state),
    trades: filterTrades(state, props),
    fileName: getFileName(state, props),
    csvRows: getCsvRows(state, props),
  }),
  actions: {
    ...Creators,
    openSecurityProfile: ProfileCreators.openSecurityProfile,
    openFactorProfile: ProfileCreators.openFactorProfile,
  },
})
